<s1-input-label [label]="label" [grouped]="labelGrouped">
  <textarea  rows="10" #inputEl class="{{ inputClass }} form-control" [ngClass]="{'is-invalid' : !checkIsValid() }" [formControl]="control" [readonly]="readonly" (ngModelChange)="onInputChange($event)"></textarea>
</s1-input-label>